import { useRouter } from "next/router";
import { getCurrentProjectId, getServerBaseUrl } from "~/lib/utils/urlHelper";
import { Project } from "~/models/project";
import {
  getHrefLangByLocale,
  getLocaleBaseUrl,
} from "~/services/locale/locale";
import { pagesPath } from "faqSrc/lib/$path";

interface Props {
  asPath?: string;
  languageAlts: string[] | undefined;
  project: Project | undefined;
}

export const pageLanguageAlternates = ({
  languageAlts,
  asPath,
  project,
}: Props): { href: string; hrefLang: string }[] | undefined => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const router = useRouter();
  const pathname = router?.pathname;
  const projectId = getCurrentProjectId();
  const serverBaseUrl = getServerBaseUrl();
  const supportLocales =
    languageAlts && languageAlts.length > 0
      ? languageAlts
      : project?.supportLocales;

  if (!supportLocales?.length) {
    return [];
  }

  // router.asPath doesn't work properly in ISR
  const path = asPath ?? router?.asPath;
  const languageAltArr = [];
  switch (pathname) {
    case pagesPath.qa._topicSlug("")._questionAnswerId("").$url().pathname:
      for (const locale of supportLocales) {
        // get base url by locale for multi domain project
        const localeBaseUrl = getLocaleBaseUrl({ locale, projectId });
        const lang = getHrefLangByLocale({ locale });
        if (!lang) {
          continue;
        }
        languageAltArr.push({
          href: `${localeBaseUrl || serverBaseUrl}${path}`,
          hrefLang: lang,
        });
      }
      break;
    default:
      for (const locale of supportLocales) {
        const lang = getHrefLangByLocale({ locale });
        if (!lang) {
          continue;
        }
        languageAltArr.push({
          href: `${serverBaseUrl}${
            locale !== router.defaultLocale ? `/${locale}` : ""
          }${path}`,
          hrefLang: lang,
        });
      }
      break;
  }

  return languageAltArr?.length ? languageAltArr : undefined;
};
